import sortBy from 'lodash.sortby';

const ENABLE = 'enable';
const DISABLE = 'disable';

/**
 * Folds a plan's audit log into activation periods.
 *
 * The BFF returns a flat event stream (`{ timestamp, action }`), but the side
 * modal renders intervals: an `enable` opens a period, a `disable` closes the
 * open one, and a trailing `enable` stays open (`deactivated_at: null`) —
 * which is how the screen shows that the plan is active right now.
 *
 * `status` is not read: it is redundant with `action`.
 *
 * Defensive about a stream that doesn't alternate, since a period is derived
 * from two separate events: an `enable` while a period is already open is
 * ignored, and so is a `disable` with nothing open.
 *
 * @param {Array} auditLogs `[{ timestamp, action }]`, in any order
 * @returns {Array} `[{ activated_at, deactivated_at }]`, oldest first
 */
export const buildActivationPeriods = (auditLogs,) => {
  const events = sortBy(
    (auditLogs || []).filter((log,) => log && log.timestamp,),
    (log,) => new Date(log.timestamp,).getTime(),
  );

  const periods = [];
  let open = null;

  events.forEach((event,) => {
    if (event.action === ENABLE && !open) {
      open = { activated_at: event.timestamp, deactivated_at: null, };
      periods.push(open,);

      return;
    }

    if (event.action === DISABLE && open) {
      open.deactivated_at = event.timestamp;
      open = null;
    }
  },);

  return periods;
};

export default buildActivationPeriods;
